<template>
  <div>
    <data-tables
      :data="current"
      :pagination-props="paginationDef"
      :table-props="tableProps"
      :show-action-bar="false"
      :filters="[searchDef]"
      style="width: 100%"
      v-loading="loading"
      class="tracker-table"
    >
      <el-row class="table-header" slot="tool">
        <el-col class="table-header-name">
          <span>Supermetrics Fields</span>
        </el-col>
        <el-col class="table-header-container">
          <div style="flex: 1; margin-right: 0.5rem">
            <el-select v-model="selected" size="small">
              <el-option label="Google" value="AW"></el-option>
              <el-option label="Facebook" value="FA"></el-option>
              <el-option label="Bing" value="AC"></el-option>
            </el-select>
          </div>
          <div style="flex: 1">
            <el-input
              v-model="searchDef.value"
              placeholder="Search By Field Name..."
              size="small"
            >
              <i slot="prefix" class="el-input__icon el-icon-search"></i>
            </el-input>
          </div>
          <div style="flex: 0; margin-left: 0.5rem">
            <el-tooltip effect="dark" placement="bottom">
              <div slot="content">
                Click here to manually update fields. Fields are automatically
                updated on a daily basis.
              </div>
              <el-button @click="update" type="primary" size="small">
                <font-awesome-icon
                  icon="sync-alt"
                  :spin="loading"
                  fixed-width
                ></font-awesome-icon>
                Update Fields
              </el-button>
            </el-tooltip>
          </div>
        </el-col>
      </el-row>

      <el-table-column
        prop="group"
        label="Group"
        sortable="custom"
        show-overflow-tooltip
      ></el-table-column>

      <el-table-column
        prop="name"
        label="Field"
        sortable="custom"
        show-overflow-tooltip
      ></el-table-column>

      <el-table-column
        prop="type"
        label="Type"
        sortable="custom"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          {{ scope.row.type === "dim" ? "Dimension" : "Metric" }}
        </template>
      </el-table-column>

      <el-table-column
        prop="f"
        label="Filterable"
        sortable="custom"
        width="100"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <font-awesome-icon
            v-if="scope.row.f === 1"
            icon="check"
            fixed-width
          ></font-awesome-icon>
        </template>
      </el-table-column>
    </data-tables>
  </div>
</template>

<script>
export default {
  name: "TrackerSupermetricsFieldsTable",
  data() {
    return {
      data: [],
      searchDef: {
        value: "",
        prop: "name",
      },
      sortMethod(a, b) {
        if (isNaN(a)) {
          return a.localeCompare(b)
        } else {
          return a > b ? 1 : a < b ? -1 : 0
        }
      },
      paginationDef: {
        pageSize: 20,
        pageSizes: [20],
        layout: "prev, pager, next",
      },
      tableProps: {
        border: false,
        stripe: true,
        defaultSort: {
          prop: "group",
          order: "ascending",
        },
      },
      loading: false,
      selected: "AW",
    }
  },
  computed: {
    current() {
      if (!this.data.length === 0) return []
      return this.data[this.selected]
    },
  },
  methods: {
    async fetch() {
      this.loading = true
      await this.axios
        .get("supermetrics/fields?raw=true")
        .then(({ data }) => (this.data = data.data))
      this.loading = false
    },
    async update() {
      this.loading = true
      await this.axios
        .get("supermetrics/fields/update?raw=true")
        .then(({ data }) => {
          this.$message.success("Successfully updated Supermetrics fields.")
          this.data = data.data
        })
        .catch((resp) => {
          this.$root.globalRequestError(resp)
        })
      this.loading = false
    },
  },
  mounted() {
    this.fetch()
  },
}
</script>

<style scoped lang="scss">
</style>
